module.exports = __webpack_public_path__ + "banquet/components/images/chevron_teal.82924faf82cf4bf47a92c4937c8cd9dc.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/chevron_teal.svg
// module id = 1703
// module chunks = 1